// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"App_Wrapper__y-F3q"};